module.exports = __webpack_public_path__ + "img/math-6-en.921f8eda.png";